import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons';

import CalculationModeFormGroup from './calculation_mode_form_group';
import CohortFormGroup from './cohort_form_group';
import FormTier from './tier';
import ManagedFormGroup from 'components/form/managed_input/form_group';
import ResetPeriodFormGroup from './reset_period_form_group';
import StartDateFormGroup from './start_date_form_group';
import { formatTiers, isReadOnly } from './helpers';

class CommissionPlanForm extends React.Component {
  static propTypes = {
    allowCohorts: PropTypes.bool,
    enabledRealCalculationModes: PropTypes.arrayOf(PropTypes.string),
    plan: PropTypes.shape({
      archived: PropTypes.bool,
      name: PropTypes.string,
      tiers: PropTypes.array.isRequired
    }).isRequired,
    onChange: PropTypes.func.isRequired,
  }

  get readOnly() {
    return isReadOnly(this.props.plan);
  }

  handleAddTier = () => {
    const tiers = [...this.props.plan.tiers];

    if (tiers.length > 0) {
      tiers.push({ ...tiers.pop(), to: 0 });
    }

    tiers.push({ brokerSplit: 0 });

    this.props.onChange({ tiers });
  }

  handleTierChange = (tier, index) => {
    const tiers = [...this.props.plan.tiers];
    tiers[index] = tier;
    this.props.onChange({ tiers });
  }

  render() {
    return (
      <div>
        {this.renderReadOnlyWarning()}
        <div className="form form-horizontal mb-4">
          {this.renderNameInput()}

          <ResetPeriodFormGroup
            disabled={this.readOnly}
            plan={this.props.plan}
            onChange={this.props.onChange}
          />

          <StartDateFormGroup
            disabled={this.readOnly}
            plan={this.props.plan}
            onChange={this.props.onChange}
          />

          <CalculationModeFormGroup
            disabled={this.readOnly}
            enabledRealCalculationModes={this.props.enabledRealCalculationModes}
            plan={this.props.plan}
            onChange={this.props.onChange}
          />

          <CohortFormGroup
            allowCohorts={this.props.allowCohorts}
            disabled={this.readOnly}
            plan={this.props.plan}
            onChange={this.props.onChange}
          />
        </div>

        <label>Commission Tiers</label>
        {this.renderTiers()}

        {!this.readOnly && (
          <a className="clickable" name="add-tier" onClick={this.handleAddTier}>
            + Add tier
          </a>
        )}
      </div>
    );
  }

  renderNameInput() {
    return (
      <ManagedFormGroup
        disabled={this.props.plan.archived}
        label="Name"
        name="name"
        required
        value={this.props.plan.name}
        onChange={this.props.onChange}
      />
    );
  }

  renderTiers() {
    const { tiers } = this.props.plan;

    return (
      <table className="table table-condensed table-bordered tiers-table">
        <thead>
          <tr>
            <th>From</th>
            <th>To</th>
            <th>Broker Split %</th>
          </tr>
        </thead>

        <tbody>
          {formatTiers(this.props.plan.tiers).map((tier, i) => (
            <FormTier
              index={i}
              key={i}
              readOnly={this.readOnly}
              tier={tier}
              unlimited={i === tiers.length - 1}
              onChange={this.handleTierChange}
            />
          ))}
        </tbody>
      </table>
    );
  }

  renderReadOnlyWarning() {
    if (this.readOnly && !this.props.plan.archived) {
      const message = `The commission plan has already been used for ` +
        `payments and some of the information cannot be edited.`;
      return (
        <div className="alert alert-warning text-center" name="read-only-warning">
          <div>
            <FontAwesomeIcon className="warning-icon" icon={faExclamationTriangle} />
          </div>
          {message}
        </div>
      );
    }
  }
}

export default CommissionPlanForm;
